const cnamgsMenu = {
  patient: [
    {
      label: "Tableau de bord",
      link: "/patient/accueil",
      icon: "ri-dashboard-line"
    },
    {
      label: "Ma carte électronique",
      link: "/patient/card",
      icon: "ri-user-line"
    },
    {
      label: "Mes ordonnances",
      link: "/patient/prescriptions",
      icon: "ri-file-list-line"
    },
    {
      label: "Mes remboursements",
      link: "/patient/remboursements",
      icon: "ri-money-euro-circle-line"
    },
    {
      label: "Mon dossier médical",
      link: "/patient/medical-record",
      icon: "ri-file-list-line"
    },
    {
      label: "Histo. consultations",
      link: "/patient/history",
      icon: "ri-history-line"
    }
  ],
  
  doctor: [
    {
      label: "Accueil",
      link: "/doctor/accueil",
      icon: "ri-home-line"
    },
    {
      label: "Rechercher patient",
      link: "/doctor/search",
      icon: "ri-search-line"
    },
    // {
    //   label: "Prescrire",
    //   link: "/doctor/prescribe",
    //   icon: "ri-file-list-line"
    // },
    {
      label: "Mes patients",
      link: "/doctor/patients",
      icon: "ri-user-star-line"
    },
    {
      label: "Agenda",
      link: "/doctor/agenda",
      icon: "ri-calendar-line"
    },
    {
      label: "Rapports",
      link: "/doctor/reports",
      icon: "ri-file-chart-line"
    }
  ],
  
  pharmacist: [
    {
      label: "Accueil",
      link: "/pharmacist/accueil",
      icon: "ri-home-line"
    },
    {
      label: "Vérifier patient",
      link: "/pharmacist/verify",
      icon: "ri-check-double-line"
    },
    {
      label: "Délivrer ordonnance",
      link: "/pharmacist/dispense",
      icon: "ri-medicine-bottle-line"
    },
    {
      label: "Dmd. remboursement",
      link: "/pharmacist/requests",
      icon: "ri-file-copy-line"
    }
  ],
  
  admin: [
    {
      label: "Dashboard",
      link: "/admin/accueil",
      icon: "ri-dashboard-line"
    },
    {
      label: "Remboursements",
      link: "/admin/reimbursements",
      icon: "ri-money-euro-circle-line"
    },
    {
      label: "Alertes fraude",
      link: "/admin/frauds",
      icon: "ri-alert-line"
    },
    {
      label: "Gestion des structures",
      link: "/admin/structures",
      icon: "ri-hospital-line"
    },
    {
      label: "Gestion utilisateurs",
      link: "/admin/users",
      icon: "ri-user-settings-line"
    },
    {
      label: "Statistiques",
      link: "/admin/statistics",
      icon: "ri-bar-chart-2-line"
    },
    {
      label: "Rapports financiers",
      link: "/admin/reports",
      icon: "ri-file-chart-line"
    },
    {
      label: "Paramètres système",
      link: "/admin/settings",
      icon: "ri-settings-4-line"
    }
  ]
};

export default cnamgsMenu;